/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  orden: { width: '15%' },
  suscriptores: { width: '25%' },
  cuotasRegularizadas: { width: '15%' },
  adecuacionesRegularizadas: { width: '15%' },
  totalRegularizado: { width: '15%' },
  acciones: { width: '15%' },
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    LOAD_DATA: 'Datos cargados exitosamente',
  },
  ERROR: {
    LOAD_DATA: 'Error al cargar los datos',
    PRINT_DOCUMENT: 'Error al imprimir el documento',
  },
  INFO: {
    NO_DATA: 'No se encontraron planes regularizados',
    LOADING: 'Cargando datos...',
  },
};

/**
 * Configuración de validaciones
 */
export const VALIDATION_RULES = {
  CONTRACT_NUMBER: {
    MIN_LENGTH: 1,
    MAX_LENGTH: 50,
  },
};

/**
 * Configuración de formatos
 */
export const FORMAT_CONFIG = {
  DATE: {
    INPUT: 'YYYY-MM-DD',
    DISPLAY: 'DD/MM/YYYY',
  },
  CURRENCY: {
    LOCALE: 'es-AR',
    CURRENCY: 'ARS',
    DECIMALS: 2,
  },
};

/**
 * Estados de regularización
 */
export const REGULARIZATION_STATUS = {
  PENDING: 'pending',
  PARTIAL: 'partial',
  COMPLETE: 'complete',
};

/**
 * Tipos de regularización
 */
export const REGULARIZATION_TYPES = {
  FIRST: 'primera',
  SECOND: 'segunda',
};

/**
 * Breakpoints para responsividad
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};